import App from "../../core/facade";

App.on("coupons_index:init", function() {
  App.log("Coupons page init");
  App.Coupons();
  App.ToggleDropdown();
});
